exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unsubscribe[data-v-108c4af1]{background-color:#ff5b60;margin-bottom:-32px;min-height:calc(100vh - 281px);display:flex;align-items:center;justify-content:center}.unsubscribe .unsubscribe-message[data-v-108c4af1]{font-size:24px;font-weight:700;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-108c4af1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/Unsubscribe.vue
// module id = 424
// module chunks = 0